$(document).ready(function () {

    let phoneContainer = '.phones_container .select_btn_wrapper button'

    $(phoneContainer).on('click', function (e) {
        e.stopPropagation()

        $(phoneContainer).removeClass('active_btn')
        $(this).addClass('active_btn')
        let trigger = $(this).data('trigger')
        let phoneElement = '.phones_container .phone_section .phone_card'

        if (trigger !== '') {
            $(phoneElement).hide();
        } else {
            $(phoneElement).show();
            return;
        }
        
        let filters = trigger.split(',');

        for (let index = 0; index < filters.length; index++) {
            $('.phones_container .phone_section .phone_card[data-brand="'+ filters[index] +'"]').show()
        }
    })

    // Function to get query parameters from URL
    function getQueryParams() {
        var queryParams = {};
        var queryString = window.location.search.substring(1);
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            queryParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        return queryParams;
    }

    var params = getQueryParams();
    var filter = params['filter'];

    if (filter) {
        var button = $('#filter-' + filter);

        if (button.length > 0) {
            button.click();
        }
    }

    // let rng = $("#range")
    // let ro = $("#rangeValue")
    // let myRange = $(rng).data('ranges')
    //
    // function updateRange() {
    //     $('.phone_price p[key]').hide()
    //     $('.phone_price p[key="'+ $(rng).val() +'"]').show()
    //
    //     $('.single_phone_section .single_btn_wrapper form[key]').hide()
    //     $('.single_phone_section .single_btn_wrapper form[key="'+ $(rng).val() +'"]').show()
    //
    //     $(ro).text(myRange[parseInt($(rng).val(), 10)])
    // }
    //
    // window.addEventListener("DOMContentLoaded", updateRange)
    // $(rng).on("input", updateRange)

    $('#color_select').on('change', function () {
        window.location.href = $(this).val()
    })

    $('.single_phone_section .info_tabs div').on('click', function (e) {
        e.preventDefault()

        $('.single_phone_section .info_tabs div').removeClass('active')
        $(this).addClass('active')
        let tab = $(this).data('tab')

        $('.single_phone_section .tabs').hide();
        $('.single_phone_section .tabs.'+ tab).show();
    })
})
